import { SignJWT } from "jose";
import env from '../utils/env';

export const generateToken = async (payload, expireTime) => {
  const secret = new TextEncoder().encode(
    env.DESKTOP_APP_JWT_SECRET
  );
  const token = await new SignJWT(payload)
    .setProtectedHeader({ alg: "HS256" })
    .setExpirationTime(expireTime)
    .sign(secret);

  console.log("Generated JWT:", token);
  return token;
};
